import { NativeElement2p8z5z0r9meck as NativeElement } from '../NativeElement.commonHtml.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SeparatorClass;
function Separator() {
  if (SeparatorClass === VOID) {
    class $ extends NativeElement() {
      constructor(context) {
        super(context);
        this.native_1.tag_1 = 'div';
        this.native_1.classes_1.add_utx5q5_k$('kiteui-separator');
      }
    }
    initMetadataForClass($, 'Separator');
    SeparatorClass = $;
  }
  return SeparatorClass;
}
//region block: exports
export {
  Separator as Separator36hc2oubnyjy3,
};
//endregion

//# sourceMappingURL=Separator.commonHtml.mjs.map
